import React from 'react';
import { useCurrencyContext } from '../../context/CurrencyContext';
export function MiniBonuses() {
  const {
    formatPrice,
    loading
  } = useCurrencyContext();
  const bonusPrice = loading ? '...' : formatPrice(18);
  return <div className="w-full max-w-sm mx-auto mb-6" data-id="element-132">
      {/* Label */}
      <p className="text-[#4FD1C5] uppercase tracking-widest text-[10px] font-black mb-3 text-center" data-id="element-133">
        🎁 TAMBIÉN INCLUIDO — GRATIS
      </p>

      {/* Two bonuses stacked compactly */}
      <div className="flex flex-col gap-2 bg-white/5 border border-white/10 rounded-xl p-3" data-id="element-134">
        {/* Bono 1 */}
        <div className="flex items-center gap-3" data-id="element-135">
          <div className="relative flex-shrink-0" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/qb55CB1aJArEog9RXn8XMq/bono1.png" alt="Bono 1" className="w-10 h-10 rounded-md object-cover" data-id="element-137" />
            <span className="absolute -top-1 -right-1 bg-[#4FD1C5] text-[#101322] text-[8px] font-black rounded-full w-4 h-4 flex items-center justify-center" data-id="element-138">
              1
            </span>
          </div>
          <div className="flex-1 text-left min-w-0" data-id="element-139">
            <p className="text-white font-bold text-xs leading-tight truncate" data-id="element-140">
              Hacélo Aunque No Tengas Ganas
            </p>
            <p className="text-[10px] font-[600] text-[#DCDCDC]" data-id="element-141">
              Guión de 7 min para arrancar
            </p>
          </div>
          <div className="flex-shrink-0 text-right" data-id="element-142">
            <span className={`line-through text-[10px] block text-[#FFFFFF] ${loading ? 'animate-pulse' : ''}`} data-id="element-143">
              {bonusPrice}
            </span>
            <span className="font-black text-xs text-[#4DFF53]" data-id="element-144">GRATIS</span>
          </div>
        </div>

        <div className="h-px bg-white/5" data-id="element-145" />

        {/* Bono 2 */}
        <div className="flex items-center gap-3" data-id="element-146">
          <div className="relative flex-shrink-0" data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/411b5cXAQcyYah7Krk9x9U/bono2.png" alt="Bono 2" className="w-10 h-10 rounded-md object-cover" data-id="element-148" />
            <span className="absolute -top-1 -right-1 bg-[#4FD1C5] text-[#101322] text-[8px] font-black rounded-full w-4 h-4 flex items-center justify-center" data-id="element-149">
              2
            </span>
          </div>
          <div className="flex-1 text-left min-w-0" data-id="element-150">
            <p className="text-white font-bold text-xs leading-tight truncate" data-id="element-151">
              Cuando Me Pega el Bajón
            </p>
            <p className="text-[10px] font-[600] text-[#DCDCDC]" data-id="element-152">
              Ritual de 12 min para salir del bajón
            </p>
          </div>
          <div className="flex-shrink-0 text-right" data-id="element-153">
            <span className={`line-through text-[10px] block text-[#FFFFFF] ${loading ? 'animate-pulse' : ''}`} data-id="element-154">
              {bonusPrice}
            </span>
            <span className="font-black text-xs text-[#4DFF53]" data-id="element-155">GRATIS</span>
          </div>
        </div>
      </div>
    </div>;
}